import { Plus, Video, Play, Trash2, ImagePlus, Loader2, X } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const VideosTab = ({ newTutorial, setNewTutorial, handleAddTutorial, tutorialLoading, tutorials, groupedTutorials, handleDeleteTutorial, secretosOptions, handleThumbnailUpload, thumbnailUploading }) => (
  <>
    {/* Add New Tutorial */}
    <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-4 border border-slate-200 dark:border-slate-700">
      <h3 className="text-sm font-semibold text-[#1D1D1B] dark:text-white flex items-center gap-2 mb-4">
        <Plus className="h-4 w-4 text-[#80C753]" />
        Agregar Nuevo Video
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-sm">Curso / Secreto {newTutorial.location === 'academia' ? '(opcional)' : '*'}</Label>
          <Select value={newTutorial.secreto} onValueChange={(value) => setNewTutorial({ ...newTutorial, secreto: value })}>
            <SelectTrigger className="bg-white dark:bg-slate-800">
              <SelectValue placeholder="Selecciona un Secreto" />
            </SelectTrigger>
            <SelectContent>
              {secretosOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label className="text-sm">Orden</Label>
          <Input type="number" placeholder="0" value={newTutorial.order}
            onChange={(e) => setNewTutorial({ ...newTutorial, order: parseInt(e.target.value) || 0 })}
            className="bg-white dark:bg-slate-800" />
        </div>

        <div className="space-y-2 md:col-span-2">
          <Label className="text-sm">¿Dónde se cuelga este video? *</Label>
          <Select value={newTutorial.location || 'home'} onValueChange={(value) => setNewTutorial({ ...newTutorial, location: value })}>
            <SelectTrigger className="bg-white dark:bg-slate-800" data-testid="tutorial-location-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="home">🏠 Home (página de inicio)</SelectItem>
              <SelectItem value="educacion">🎓 Educación (/educacion)</SelectItem>
              <SelectItem value="academia">🎥 Academia (grabación en vivo / Zoom)</SelectItem>
            </SelectContent>
          </Select>
          <p className="text-[11px] text-slate-500 dark:text-slate-400">
            {newTutorial.location === 'academia'
              ? 'Se mostrará en la Academia con reproductor interno, agrupado por curso y ordenado por fecha.'
              : 'Home y Educación muestran el video como tarjeta que abre en YouTube.'}
          </p>
        </div>

        {newTutorial.location === 'academia' && (
          <>
            <div className="space-y-2">
              <Label className="text-sm">Fecha de la grabación *</Label>
              <Input type="date" value={newTutorial.recorded_date || ''}
                onChange={(e) => setNewTutorial({ ...newTutorial, recorded_date: e.target.value })}
                className="bg-white dark:bg-slate-800" data-testid="tutorial-recorded-date-input" />
            </div>
            <div className="space-y-2">
              <Label className="text-sm">Presentador (opcional)</Label>
              <Input placeholder="Ej: Carlos Fernandez" value={newTutorial.presenter || ''}
                onChange={(e) => setNewTutorial({ ...newTutorial, presenter: e.target.value })}
                className="bg-white dark:bg-slate-800" />
            </div>
          </>
        )}

        <div className="space-y-2 md:col-span-2">
          <Label className="text-sm">Título del Video *</Label>
          <Input placeholder="Ej: Cómo usar Certiviaje" value={newTutorial.title}
            onChange={(e) => setNewTutorial({ ...newTutorial, title: e.target.value })}
            className="bg-white dark:bg-slate-800" data-testid="tutorial-title-input" />
        </div>

        <div className="space-y-2 md:col-span-2">
          <Label className="text-sm">URL del Video (YouTube, Vimeo, etc.) *</Label>
          <Input placeholder="https://www.youtube.com/watch?v=..." value={newTutorial.url}
            onChange={(e) => setNewTutorial({ ...newTutorial, url: e.target.value })}
            className="bg-white dark:bg-slate-800" data-testid="tutorial-url-input" />
        </div>

        <div className="space-y-2 md:col-span-2">
          <Label className="text-sm">Descripción (opcional)</Label>
          <Textarea placeholder="Breve descripción del video..." value={newTutorial.description}
            onChange={(e) => setNewTutorial({ ...newTutorial, description: e.target.value })}
            className="bg-white dark:bg-slate-800 min-h-[60px]" />
        </div>

        <div className="space-y-2 md:col-span-2">
          <Label className="text-sm">Portada personalizada (opcional)</Label>
          {newTutorial.thumbnail ? (
            <div className="flex items-center gap-3">
              <img src={newTutorial.thumbnail} alt="Portada" className="h-16 w-28 object-cover rounded-lg border border-slate-200 dark:border-slate-700" />
              <Button type="button" variant="outline" size="sm" data-testid="tutorial-thumbnail-remove"
                onClick={() => setNewTutorial({ ...newTutorial, thumbnail: '' })}
                className="text-red-500">
                <X className="h-4 w-4 mr-1" /> Quitar
              </Button>
            </div>
          ) : (
            <label className="flex items-center gap-2 cursor-pointer rounded-lg border border-dashed border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-4 py-3 text-sm text-slate-500 hover:border-[#80C753] transition-colors w-fit">
              {thumbnailUploading ? <Loader2 className="h-4 w-4 animate-spin text-[#80C753]" /> : <ImagePlus className="h-4 w-4 text-[#80C753]" />}
              <span>{thumbnailUploading ? 'Subiendo...' : 'Subir imagen de portada'}</span>
              <input type="file" accept="image/*" className="hidden" data-testid="tutorial-thumbnail-input"
                disabled={thumbnailUploading}
                onChange={(e) => { handleThumbnailUpload(e.target.files?.[0]); e.target.value = ''; }} />
            </label>
          )}
          <p className="text-[11px] text-slate-500 dark:text-slate-400">Si no subes una, se usa automáticamente la miniatura de YouTube. (Máx 5 MB)</p>
        </div>
      </div>

      <Button onClick={handleAddTutorial} disabled={tutorialLoading} className="mt-4 bg-[#80C753] hover:bg-[#6ab043] text-white">
        {tutorialLoading ? <Plus className="h-4 w-4 mr-2 animate-spin" /> : <Plus className="h-4 w-4 mr-2" />}
        {tutorialLoading ? 'Agregando...' : 'Agregar Video'}
      </Button>
    </div>

    {/* Existing Tutorials */}
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-[#1D1D1B] dark:text-white flex items-center gap-2">
        <Video className="h-4 w-4 text-[#45A0EE]" />
        Videos Existentes ({tutorials.length})
      </h3>

      {Object.keys(groupedTutorials).length === 0 ? (
        <div className="text-center py-8 text-slate-400 dark:text-slate-500">
          <Video className="h-12 w-12 mx-auto mb-3 opacity-50" />
          <p>No hay videos agregados aún</p>
        </div>
      ) : (
        Object.entries(groupedTutorials).map(([secreto, videos]) => (
          <div key={secreto} className="border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden">
            <div className="bg-slate-100 dark:bg-slate-800 px-4 py-2 font-semibold text-sm text-[#1D1D1B] dark:text-white">
              {secreto}
              <span className="ml-2 text-xs text-slate-500">({videos.length} videos)</span>
            </div>
            <div className="divide-y divide-slate-100 dark:divide-slate-700">
              {videos.map((tutorial) => (
                <div key={tutorial.id} className="flex items-center gap-3 px-4 py-3 hover:bg-slate-50 dark:hover:bg-slate-800/50">
                  {tutorial.thumbnail ? (
                    <img src={tutorial.thumbnail} alt="" className="h-9 w-14 object-cover rounded flex-shrink-0 border border-slate-200 dark:border-slate-700" />
                  ) : (
                    <Play className="h-4 w-4 text-red-500 flex-shrink-0" />
                  )}
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-[#1D1D1B] dark:text-white truncate">
                      {tutorial.title}
                      {tutorial.thumbnail && <span className="ml-2 text-[9px] font-bold text-[#80C753] uppercase">· portada propia</span>}
                    </p>
                    <p className="text-xs text-slate-500 dark:text-slate-400 truncate">{tutorial.url}</p>
                    {tutorial.description && (
                      <p className="text-xs text-slate-400 dark:text-slate-500 mt-1 truncate">{tutorial.description}</p>
                    )}
                  </div>
                  <span className={`text-[10px] font-bold px-2 py-1 rounded-full whitespace-nowrap ${(tutorial.location || 'home') === 'educacion' ? 'bg-[#45A0EE]/15 text-[#45A0EE]' : (tutorial.location === 'academia' ? 'bg-[#C9A84C]/15 text-[#C9A84C]' : 'bg-[#80C753]/15 text-[#5a9e33]')}`}>
                    {(tutorial.location || 'home') === 'educacion' ? '🎓 Educación' : (tutorial.location === 'academia' ? '🎥 Academia' : '🏠 Home')}
                  </span>
                  <span className="text-xs text-slate-400 px-2 py-1 bg-slate-100 dark:bg-slate-700 rounded">#{tutorial.order}</span>
                  <Button variant="ghost" size="icon" onClick={() => window.open(tutorial.url, '_blank')} className="h-8 w-8 text-[#45A0EE]">
                    <Play className="h-4 w-4" />
                  </Button>
                  <Button variant="ghost" size="icon" onClick={() => handleDeleteTutorial(tutorial.id)}
                    className="h-8 w-8 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20">
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  </>
);

export default VideosTab;
